import { GetResults } from '@/commands/get.results';
import { DynamicListResult, Facet, Query } from '@/models/dynamiclist';
import { State } from '@/types';
import _ from 'lodash';
import { ActionContext, ActionTree } from 'vuex';
import { FacetQuery, FilterQuery, PagingOptions } from '../models/dynamiclist';

export const actions: ActionTree<State, any> = {
    fetchResults: (context) => {
        // Formats filterQueries as property before submitting to API (MVC hack)
        const filterQueriesFormatted = [] as Array<{ key: string, value: FilterQuery<any> }>;

        for (const key in context.state.query.filterQueries) {
            if (context.state.query.filterQueries.hasOwnProperty(key)) {
                const filterQuery = Object.assign({}, context.state.query.filterQueries[key]);
                // Serializes all filter object values as a string if it isn't already one (MVC hack)
                if (typeof filterQuery.value !== 'string' && !(filterQuery.value instanceof String)) {
                    filterQuery.value = JSON.stringify(filterQuery.value);
                }

                filterQueriesFormatted.push({
                    key,
                    value: filterQuery
                });
            }
        }

        context.dispatch(
            'getResults', {
                listId: context.state.data.id,
                query: {
                    cultureOptions: context.getters.query.cultureOptions,
                    filterQueries: filterQueriesFormatted as any,
                    pagingOptions: context.getters.query.pagingOptions
                } as Query
            } as GetResults
        );
    },
    fetchResultsDebounced: _.debounce((context: ActionContext<State, any>) => {
        context.commit('resetPagingOptions');
        context.dispatch('fetchResults');
    }, 500),
    getResults: (context, command: GetResults) => {
        context.state.apiService
            .post<DynamicListResult>(`${command.listId}`, command.query)
            .subscribe(
                res => {
                    context.commit('setData', res.data);
                    context.commit('setResults', res.results);
                    context.commit('setPager', res.pager);
                    context.commit('setCounter', res.counter);
                },
                error => context.commit('setError', error)
            );
    },
    toggleFacet: (context: ActionContext<State, any>, cmd: { filterId: string, facetId: string }) => {
        const selectedFacets = context.getters.selectedFacets as unknown as { [filterId: string]: Facet[] };
        const exists = selectedFacets[cmd.filterId].filter(facet => facet.id === cmd.facetId).length > 0;

        let facetQueryValue = Object.assign(
            {},
            context.getters.filterQuery(cmd.filterId) as unknown as FacetQuery
        ).value;

        if (!exists) {
            facetQueryValue.push(cmd.facetId);
        } else {
            facetQueryValue = facetQueryValue.filter(fv => fv !== cmd.facetId);
        }

        context.commit('setFilterQueryValue', {
            filterId: cmd.filterId,
            value: facetQueryValue
        });
    },
    changePage: (context: ActionContext<State, any>, page: number) => {
        const pagingOptions = context.getters.pagingOptions as PagingOptions;
        pagingOptions.page = page;

        context.commit('setPagingOptions', pagingOptions);
        context.dispatch('fetchResults');
    },
    clearFacets: (context: ActionContext<State, any>) => {
        const selectedFacets = context.getters.selectedFacets as unknown as { [filterId: string]: Facet[] };

        for (const filterId of Object.keys(selectedFacets)) {
            for (const facet of selectedFacets[filterId]) {
                context.dispatch('toggleFacet', { filterId, facetId: facet.id });
            }
        }
    }
};
